// quarters.js
var DKT = DKT || {};
DKT.quarters = function(tamborradasPorZona, selectedZoneId) {
  function getSelectedQuarterData() {
    var selectedQuarterData = tamborradasPorZona.filter(function(quarterData) {
      return quarterData.id === selectedZoneId;
    });

    if (selectedQuarterData.length > 0) {
      return selectedQuarterData[0];
    } else {
      return null;
    }
  }

  function getTamborradasFromQuarter(tamborradas, quarterData) {
    var filteredTamborradas = tamborradas.filter(function(tamborrada) {
      return tamborrada.zoneId === quarterData.id;
    });

    return filteredTamborradas;
  }

  return {
    getSelectedQuarterData: getSelectedQuarterData,
    getTamborradasFromQuarter: getTamborradasFromQuarter
  };
};
